import { useContext } from 'react';
import { SimulationContext } from '../Context/SimulationContext';

export function useSimulation() {
  const context = useContext(SimulationContext);

  return context;
}
